import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { userApi } from "@/lib/userApi";
import { playForgeGate } from "@/components/ForgeGate";

const UserAuthContext = createContext(null);

/** Sesión de usuario basada en cookie httpOnly: nada sensible se guarda en el navegador. */
export const UserAuthProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [status, setStatus] = useState("checking"); // checking | authed | guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await userApi.get("/user/auth/me");
      setProfile(data);
      setStatus("authed");
      return data;
    } catch (e) {
      setProfile(null);
      setStatus("guest");
      return null;
    }
  }, []);

  const signIn = useCallback((usr) => {
    setProfile(usr);
    setStatus("authed");
  }, []);

  const signOut = useCallback(async () => {
    try {
      await userApi.post("/user/auth/logout");
    } catch (e) {
      console.warn("No se pudo cerrar la sesión en el servidor:", e);
    }
    setProfile(null);
    setStatus("guest");
    await playForgeGate({ title: "HASTA PRONTO", subtitle: "DIGITAL FORGE TE ESPERA" });
    window.location.href = "/acceso";
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <UserAuthContext.Provider value={{
      profile, signIn, signOut, refresh,
      isAuthed: status === "authed", checking: status === "checking",
    }}>
      {children}
    </UserAuthContext.Provider>
  );
};

export const useUserAuth = () => useContext(UserAuthContext);
